import styled, { css } from 'styled-components';
import { applyStyleModifiers, type ModifiersConfig, type ModifierKeys } from 'styled-components-modifiers';
import { Modal } from 'antd';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive, size, globalContentPadding } from 'components/styles';

// Import types
import { AntModal } from 'types/libraries/antd';

// Import types
import { Modifiers } from 'types/views/styles';

const DESCRIPTION_MODIFIERS: Modifiers = {
	login: ({ theme }) => css`
		color: ${rgba(theme.palette.secondary.main, 0.65)};
	`
};

export const AntModalStyled = styled(Modal)<AntModal & { fullWidth?: boolean }>`
	width: 100% !important;
	min-height: 100vh;
	box-shadow: 0 1.4 3.4 0 ${({ theme }) => rgba(theme.black, 0.45)};
	padding: 0;

	.ant-modal-content {
		${flex({ fd: 'column' })};
		${({ fullWidth }) => !fullWidth && globalContentPadding()}
		min-height: calc(100vh - 8rem);
		gap: 4rem;
		margin: 4rem 0;
		background: none;
	}

	.ant-modal-body {
		${flex({ fd: 'column' })}
		padding: 0;
		margin: 0;
		gap: 4rem;
		width: 100%;
	}
`;

export const StyledTitle = styled.h1`
	width: 100%;
	padding: 0;
	font-size: 2.2rem;
	color: ${({ theme }) => theme.configurator.color.primary};
	font-weight: ${({ theme }) => theme.font.medium};
	white-space: pre-line;
	line-height: 1.3;
	text-align: center;
	margin-top: 4.5rem;
`;

export const HeadingFirstStyled = styled.h1`
	font-size: 2.5rem;
	font-weight: ${({ theme }) => theme.font.medium};
	color: ${({ theme }) => theme.configurator.color.primary};
	margin: 2rem 0;

	${customMinResponsive(
		size.semi,
		css`
			font-size: 3rem;
		`
	)}
	${customMinResponsive(
		size.large,
		css`
			margin-top: 6rem;
		`
	)};
`;

export const ButtonContainer = styled.div`
	${flex({ fd: 'column' })}
	margin-top: 2rem;
	gap: 1.2rem;
	width: 100%;

	${customMinResponsive(
		size.xsmall,
		css`
			${flex()}

			button {
				max-width: 50%;
			}
		`
	)}
`;

export const ModalContent = styled.div<{ maxWidth?: string; gap?: number }>`
	${flex({ fd: 'column' })}
	gap: ${({ gap = 1.6 }) => gap}rem;
	width: 100%;
	max-width: ${({ maxWidth = '55rem' }) => maxWidth};
`;

export const StyledHeading = styled.h1<{ alignSelf?: string }>`
	font-size: 2.2rem;
	line-height: 1.3;
	font-weight: ${({ theme }) => theme.font.medium};
	color: ${({ theme }) => theme.configurator.color.primary};
	align-self: ${({ alignSelf = 'center' }) => alignSelf};
`;

export const Description = styled.p<{ mb?: number; modifiers?: ModifierKeys }>`
	color: ${({ theme }) => theme.configurator.color.accent};
	font-size: 1.5rem;
	line-height: 1.5em;
	text-align: center;
	white-space: pre-line;
	margin-bottom: ${({ mb = 0 }) => mb}rem;

	${applyStyleModifiers(DESCRIPTION_MODIFIERS as ModifiersConfig)};
`;
